(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
    var stickyHeader = document.getElementsByTagName('sticky-header')[0];

    if (stickyHeader) {
        var sticky = stickyHeader.querySelector('.header-nav-hamburger');

        if (sticky && !customElements.get('sticky-header')) {
            class StickyHeader extends HTMLElement {
                constructor() {
                    super();

                    this.onScrollHandler = this.onScroll.bind(this);
                    this.onResizeHandler = this.setHeaderHeight.bind(this);
                    this.hideHeaderOnScrollUp = () => {
                        this.preventReveal = true;
                    };
                }

                connectedCallback() {
                    this.header = document.querySelector('.section-header-navigation');

                    if (!this.header) return;

                    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
                    this.headerBounds = {};
                    this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    this.preventReveal = false;
                    this.predictiveSearch = this.querySelector('predictive-search');

                    this.setHeaderHeight();

                    this.mediaQuery = window.matchMedia('(max-width: 990px)');
                    this.mediaQuery.addEventListener('change', this.onResizeHandler);

                    if (this.headerIsAlwaysSticky) {
                        this.header.classList.add('shopify-section-header-sticky');
                    }

                    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                    window.addEventListener('scroll', this.onScrollHandler, false);

                    this.createObserver();

                    /*
                        Importante:
                        Não chamamos checkLoadPosition() no load.

                        O navegador pode restaurar a posição de scroll ao recarregar a página.
                        Se checkLoadPosition() rodar nesse momento, ele pode adicionar
                        shopify-section-header-hidden logo no carregamento, fazendo o header sumir.
                    */

                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.remove('section-header-is-hidden');
                }

                disconnectedCallback() {
                    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
                    window.removeEventListener('scroll', this.onScrollHandler);

                    if (this.mediaQuery) {
                        this.mediaQuery.removeEventListener('change', this.onResizeHandler);
                    }
                }

                setHeaderHeight() {
                    if (!this.header) return;

                    document.documentElement.style.setProperty(
                        '--header-height',
                        `${this.header.offsetHeight}px`
                    );
                }

                createObserver() {
                    if (!this.header) return;

                    const observer = new IntersectionObserver((entries, observerInstance) => {
                        this.headerBounds = entries[0].intersectionRect;
                        observerInstance.disconnect();
                    });

                    observer.observe(this.header);
                }

                onScroll() {
                    if (!this.header) return;

                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

                    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                        if (this.preventHide) return;

                        this.header.classList.add('scrolled-past-header');
                        requestAnimationFrame(this.hide.bind(this));
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                        this.header.classList.add('scrolled-past-header');

                        if (!this.preventReveal) {
                            requestAnimationFrame(this.reveal.bind(this));
                        } else {
                            window.clearTimeout(this.isScrolling);

                            this.isScrolling = setTimeout(() => {
                                this.preventReveal = false;
                            }, 66);

                            requestAnimationFrame(this.hide.bind(this));
                        }
                    } else if (scrollTop <= this.headerBounds.top) {
                        this.header.classList.remove('scrolled-past-header');
                        requestAnimationFrame(this.reset.bind(this));
                    }

                    this.currentScrollTop = scrollTop;
                }

                hide() {
                    if (!this.header) return;

                    if (this.headerIsAlwaysSticky != null) {
                        if (this.headerIsAlwaysSticky === 'always') {
                            this.header.classList.add('shopify-section-header-sticky');
                            return;
                        }

                        this.header.classList.add(
                            'shopify-section-header-hidden',
                            'shopify-section-header-sticky'
                        );

                        this.header.classList.remove('shopify-section-header-show');
                        document.body.classList.add('section-header-is-hidden');
                    }

                    this.closeMenuDisclosure();
                }

                reveal() {
                    if (!this.header) return;

                    if (this.headerIsAlwaysSticky != null) {
                        if (this.headerIsAlwaysSticky === 'always') {
                            this.header.classList.add('shopify-section-header-sticky', 'animate');
                            return;
                        }

                        this.header.classList.add(
                            'shopify-section-header-sticky',
                            'shopify-section-header-show',
                            'animate'
                        );

                        this.header.classList.remove('shopify-section-header-hidden');
                        document.body.classList.remove('section-header-is-hidden');
                    }
                }

                reset() {
                    if (!this.header) return;

                    if (this.headerIsAlwaysSticky != null) {
                        if (this.headerIsAlwaysSticky === 'always') {
                            this.header.classList.add('shopify-section-header-sticky', 'animate');
                            return;
                        }

                        this.header.classList.remove(
                            'shopify-section-header-hidden',
                            'shopify-section-header-show',
                            'shopify-section-header-sticky',
                            'animate'
                        );

                        document.body.classList.remove('section-header-is-hidden');
                    }
                }

                closeMenuDisclosure() {
                    if (!this.header) return;

                    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');

                    this.disclosures.forEach((disclosure) => {
                        if (typeof disclosure.close === 'function') {
                            disclosure.close();
                        }
                    });
                }
            }

            customElements.define('sticky-header', StickyHeader);
        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            //   if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            //       if (document.body.classList.contains('template-index')) {
            //           if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
            //               $('.vertical-menu').removeClass('vertical-menu__hide');
            //           }
            //       }
            //   }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-primeira-compra"] && !Shopify.designMode) return;
  try {
    
  class KalpaWelcomePopup extends HTMLElement {
    connectedCallback() {
      this.dialogo = this.querySelector(".kwp__dialog");
      this.formulario = this.querySelector("[data-kwp-form]");
      this.erro = this.querySelector("[data-kwp-erro]");
      this.chave = "kalpa-popup-boas-vindas";
      this.chaveCadastro = "kalpa-popup-cadastrado";
      this.filaChave = "kalpa-leads-pendentes";
      this.gatilho = "";
      this.abertoEm = Date.now();
      this.preview = this.dataset.preview === "true";
      this.aberto = false;

      this.querySelectorAll("[data-kwp-close]").forEach((b) =>
        b.addEventListener("click", () => this.fechar(true))
      );
      this.addEventListener("keydown", (e) => this.aoTeclar(e));
      if (this.formulario) this.formulario.addEventListener("submit", (e) => this.enviar(e));

      this.whatsapp = this.querySelector("[data-kwp-whatsapp]");
      if (this.whatsapp) this.armarWhatsapp();

      /* Rotação muda a LARGURA e pede nova medida; teclado muda só a ALTURA e
         não pode mexer em nada enquanto a pessoa digita. É isso que separa os
         dois casos, sem heurística de pixels. */
      this.larguraAnterior = window.innerWidth;
      this.aoRedimensionar = () => {
        if (window.innerWidth === this.larguraAnterior) return;
        this.larguraAnterior = window.innerWidth;
        if (this.aberto) this.ajustarAltura();
      };
      window.addEventListener("resize", this.aoRedimensionar);

      const copiar = this.querySelector("[data-kwp-copy]");
      if (copiar) copiar.addEventListener("click", () => this.copiar(copiar));

      // Fila pendente de uma visita anterior: escoa ANTES de qualquer return.
      // Quem já se cadastrou é justamente quem tem lead preso na fila.
      this.escoarFila();
      this.lerCarrinho();

      // Qualquer peça do site pode chamar o pop-up: um link para #cupom ou um
      // elemento com data-kwp-open. É assim que a comunicação do cupom pede o
      // e-mail antes de entregar o código, em vez de espalhar o código solto.
      // Fica antes do jaViu() de propósito: quem pediu o cupom no clique quer
      // ver o pop-up mesmo tendo fechado ele antes.
      this.aoPedirAbertura = (evento) => {
        const alvo = evento.target;
        if (!alvo || !alvo.closest) return;
        const gatilho = alvo.closest('[data-kwp-open], a[href="#cupom"], a[href$="/#cupom"]');
        if (!gatilho) return;
        evento.preventDefault();
        this.abrir();
      };
      document.addEventListener("click", this.aoPedirAbertura);

      // No editor de temas ele abre na hora, senão não dá para trabalhar nele.
      if (this.preview) {
        this.abrir();
        return;
      }

      if (this.jaViu()) return;
      this.armarGatilhos();
    }

    disconnectedCallback() {
      this.desarmar();
      if (this.aoPedirAbertura) document.removeEventListener("click", this.aoPedirAbertura);
      if (this.aoRedimensionar) window.removeEventListener("resize", this.aoRedimensionar);
      if (this.aberto) this.liberarPagina();
    }

    /* Uma vez por pessoa, e ponto:
       - quem se cadastrou nunca mais vê, sem prazo para expirar;
       - quem só fechou volta a ver depois de `expire_days`, e com 0 nunca mais;
       - cliente logado não vê nada — a oferta é de primeira compra. */
    jaViu() {
      if (this.dataset.cliente === "true" && this.dataset.esconderCliente !== "false") return true;

      try {
        if (window.localStorage.getItem(this.chaveCadastro)) return true;
        const ate = window.localStorage.getItem(this.chave);
        if (!ate) return false;
        // "0" é a marca de nunca mais, gravada quando o prazo é zero.
        if (ate === "0") return true;
        return Number(ate) > Date.now();
      } catch (e) {
        return document.cookie.indexOf(this.chave + "=") !== -1;
      }
    }

    /* Cadastrou: não volta nunca mais, em nenhum prazo. */
    marcarCadastrado() {
      try {
        window.localStorage.setItem(this.chaveCadastro, String(Date.now()));
      } catch (e) {
        const dez = new Date(Date.now() + 3650 * 86400000).toUTCString();
        document.cookie = this.chaveCadastro + "=1;path=/;expires=" + dez;
      }
    }

    marcarVisto(diasForcado) {
      // Prazo zero no editor: quem fechou não vê de novo neste navegador.
      const configurado = parseInt(this.dataset.expire, 10);
      if (!diasForcado && configurado === 0) {
        try {
          window.localStorage.setItem(this.chave, "0");
        } catch (e) {
          const dez = new Date(Date.now() + 3650 * 86400000).toUTCString();
          document.cookie = this.chave + "=1;path=/;expires=" + dez;
        }
        return;
      }

      // Quem chegou a pegar o cupom não pode ver isso de novo tão cedo: some
      // por um ano. O prazo curto do editor vale para quem só fechou a janela.
      const dias = diasForcado || parseInt(this.dataset.expire, 10) || 15;
      const ate = Date.now() + dias * 86400000;
      try {
        window.localStorage.setItem(this.chave, String(ate));
      } catch (e) {
        document.cookie = this.chave + "=1;path=/;expires=" + new Date(ate).toUTCString();
      }
    }

    armarGatilhos() {
      const espera = parseInt(this.dataset.delay, 10);
      const alvo = parseInt(this.dataset.scroll, 10);

      if (espera >= 0) {
        this.temporizador = setTimeout(
          () => this.abrir("tempo-" + Math.round(espera / 1000) + "s"),
          espera
        );
      }

      if (alvo > 0) {
        this.aoRolar = () => {
          const doc = document.documentElement;
          const percorrido = doc.scrollHeight - window.innerHeight;
          if (percorrido <= 0) return;
          if ((window.scrollY / percorrido) * 100 >= alvo) this.abrir("rolagem-" + alvo + "%");
        };
        window.addEventListener("scroll", this.aoRolar, { passive: true });
      }
    }

    desarmar() {
      if (this.temporizador) clearTimeout(this.temporizador);
      if (this.aoRolar) window.removeEventListener("scroll", this.aoRolar);
    }

    abrir(gatilho) {
      if (this.aberto) return;
      this.aberto = true;
      this.gatilho = gatilho || (this.preview ? "editor" : "clique");
      this.abertoEm = Date.now();
      this.desarmar();
      this.hidden = false;

      // Segura a página sem deixar o layout pular quando a barra de rolagem some.
      const folga = window.innerWidth - document.documentElement.clientWidth;
      this.scrollGuardado = window.scrollY;
      document.body.style.paddingRight = folga > 0 ? folga + "px" : "";
      document.body.style.overflow = "hidden";

      requestAnimationFrame(() => {
        this.setAttribute("data-aberto", "true");
        this.ajustarAltura();
      });

      // A foto entra depois e muda a conta: remede quando ela chega.
      const foto = this.querySelector(".kwp__media img");
      if (foto && !foto.complete) foto.addEventListener("load", () => this.ajustarAltura(), { once: true });

      this.focoAnterior = document.activeElement;
      const primeiro = this.querySelector("input, button");
      if (primeiro && window.matchMedia("(min-width: 900px)").matches) primeiro.focus();
    }

    fechar(marcar) {
      if (!this.aberto) return;
      this.aberto = false;
      this.removeAttribute("data-aberto");
      if (marcar) this.marcarVisto();

      const esconder = () => {
        this.hidden = true;
        this.liberarPagina();
        if (this.focoAnterior && this.focoAnterior.focus) this.focoAnterior.focus();
      };

      const semAnimacao = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      semAnimacao ? esconder() : setTimeout(esconder, 320);
    }

    liberarPagina() {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    aoTeclar(e) {
      if (e.key === "Escape") {
        this.fechar(true);
        return;
      }
      if (e.key !== "Tab") return;

      const focaveis = this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      const visiveis = Array.from(focaveis).filter((el) => el.offsetParent !== null);
      if (!visiveis.length) return;

      const primeiro = visiveis[0];
      const ultimo = visiveis[visiveis.length - 1];

      if (e.shiftKey && document.activeElement === primeiro) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primeiro.focus();
      }
    }

    enviar() {
      // Não mexa na propagação nem no default deste submit. Medido em 18/08: o
      // POST para /contact quem dispara é o próprio caminho do tema, e tanto
      // `preventDefault` quanto `stopImmediatePropagation` fazem a requisição
      // simplesmente não sair — o lead ia para a planilha e o contato não
      // entrava na Shopify, calado. O que precisa acontecer aqui é só
      // enfileirar o lead e deixar o formulário seguir.
      const botao = this.formulario.querySelector(".kwp__submit");
      if (this.erro) this.erro.hidden = true;
      botao.disabled = true;

      botao.dataset.carregando = "true";

      // O visto é gravado agora, e não na volta do servidor: se a resposta
      // demorar ou falhar, o pop-up não pode voltar a brotar para quem já
      // preencheu. Cadastro não expira nunca.
      this.marcarVisto(365);
      this.marcarCadastrado();

      // O lead entra na fila ANTES de qualquer rede: se a conexão cair no meio,
      // ele é reenviado no carregamento seguinte em vez de sumir. Quem entrega
      // é o escoarFila; o POST no iframe segue para a Shopify em paralelo.
      this.enfileirar(this.montarRegistro(new FormData(this.formulario)));
      this.escoarFila();

      const sink = this.querySelector("[data-kwp-sink]");
      let concluido = false;

      const mostrarCupom = () => {
        botao.disabled = false;
        botao.dataset.carregando = "false";
        this.querySelector('[data-kwp-step="form"]').hidden = true;
        this.querySelector('[data-kwp-step="sucesso"]').hidden = false;
        this.dialogo.scrollTop = 0;
        this.ajustarAltura();

        const copiar = this.querySelector("[data-kwp-copy]");
        if (copiar) copiar.focus();
      };

      // Piso de tempo. O iframe costuma responder na hora, e a tela do cupom
      // aparecia no mesmo quadro do clique — sem ninguém ver que algo rodou.
      // 420ms é o bastante para a roda ser lida como resposta ao clique, e
      // curto o bastante para não virar espera.
      const inicio = Date.now();
      const concluir = () => {
        if (concluido) return;
        concluido = true;
        setTimeout(mostrarCupom, Math.max(0, 420 - (Date.now() - inicio)));
      };

      if (sink) {
        sink.addEventListener("load", concluir, { once: true });
      }

      // O código do cupom já está nesta página: não há nada do servidor para
      // esperar. O POST segue no iframe e o lead já está na fila da planilha,
      // então 1,2s é teto de espera, não de entrega — e não os 6s de antes,
      // que é o que a pessoa esperava quando o iframe não disparava load.
      setTimeout(concluir, 1200);
    }

    /* Aperta o card até ele caber, um degrau por vez, e para no primeiro que
       resolver. Zera os degraus antes de medir, senão a medida de agora seria
       a do estado apertado de antes (rotação, troca de passo). */
    ajustarAltura() {
      const degraus = ["kwp--c1", "kwp--c2", "kwp--c3", "kwp--c4"];
      degraus.forEach((c) => this.classList.remove(c));
      if (!this.dialogo) return;
      for (const degrau of degraus) {
        if (this.dialogo.scrollHeight <= this.dialogo.clientHeight + 1) return;
        this.classList.add(degrau);
      }
    }

    /* WhatsApp: máscara enquanto digita e recusa o que não é celular.
       A trava do envio é a validação NATIVA do campo (setCustomValidity): campo
       inválido nem dispara submit, e assim o `enviar` continua sem tocar em
       preventDefault — que é o que faria o POST para a Shopify não sair. */
    armarWhatsapp() {
      const campo = this.whatsapp;

      const formatar = () => {
        const cursorNoFim = campo.selectionStart === campo.value.length;
        campo.value = this.mascararWhatsapp(this.digitosWhatsapp(campo.value));
        if (cursorNoFim) campo.setSelectionRange(campo.value.length, campo.value.length);
        this.conferirWhatsapp();
      };

      campo.addEventListener("input", formatar);
      campo.addEventListener("blur", formatar);
      campo.addEventListener("invalid", (e) => {
        // Só suprime o balão do navegador; o submit segue bloqueado por ele.
        e.preventDefault();
        campo.setAttribute("aria-invalid", "true");
        if (this.erro) {
          this.erro.textContent = campo.validationMessage || campo.dataset.erro || "";
          this.erro.hidden = false;
        }
        campo.focus();
      });
    }

    /* Só os dígitos do celular, sem país e sem zero de operadora. Aceita quem
       cola "+55 (34) 99999-9999" ou "034 99999-9999". */
    digitosWhatsapp(valor) {
      let d = String(valor || "").replace(/\D+/g, "");
      if (d.length > 11 && d.slice(0, 2) === "55") d = d.slice(2);
      if (d.length === 12 && d.charAt(0) === "0") d = d.slice(1);
      return d.slice(0, 11);
    }

    mascararWhatsapp(d) {
      if (!d) return "";
      if (d.length <= 2) return "(" + d;
      if (d.length <= 7) return "(" + d.slice(0, 2) + ") " + d.slice(2);
      return "(" + d.slice(0, 2) + ") " + d.slice(2, 7) + "-" + d.slice(7);
    }

    /* Celular, não fixo: 11 dígitos, DDD que existe, nono dígito 9 e nada de
       sequência repetida (o "99999-9999" que as pessoas digitam para escapar). */
    whatsappValido(d) {
      const DDDS = "11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,63,64,65,66,67,68,69,71,73,74,75,77,79,81,82,83,84,85,86,87,88,89,91,92,93,94,95,96,97,98,99";
      if (d.length !== 11) return false;
      if (DDDS.indexOf(d.slice(0, 2)) === -1) return false;
      if (d.charAt(2) !== "9") return false;
      if (/^(\d)\1{8}$/.test(d.slice(2))) return false;
      return true;
    }

    conferirWhatsapp() {
      const campo = this.whatsapp;
      if (!campo) return;
      const d = this.digitosWhatsapp(campo.value);
      // Vazio fica com o `required` nativo, que já diz o que falta.
      const ok = d.length === 0 || this.whatsappValido(d);
      campo.setCustomValidity(ok ? "" : campo.dataset.erro || "Número de WhatsApp inválido");
      if (ok) {
        campo.removeAttribute("aria-invalid");
        if (this.erro) this.erro.hidden = true;
      }
    }

    whatsappE164() {
      if (!this.whatsapp) return "";
      const d = this.digitosWhatsapp(this.whatsapp.value);
      return this.whatsappValido(d) ? "55" + d : "";
    }

    montarRegistro(dados) {
      const url = new URL(location.href);
      const p = (c) => url.searchParams.get(c) || "";
      const guardado = this.origemDaSessao(url);
      const cookie = (n) => {
        const m = document.cookie.match(new RegExp("(^|;\\s*)" + n + "=([^;]*)"));
        return m ? decodeURIComponent(m[2]) : "";
      };
      const ga = cookie("_ga");
      const carrinho = this.carrinho || { itens: "", valor: "" };
      const armadilha = this.querySelector("[data-kwp-armadilha]");

      return {
        token: this.dataset.leadsToken || "",
        winnie: armadilha ? armadilha.value : "",
        nome: String(dados.get("contact[first_name]") || "").trim(),
        email: String(dados.get("contact[email]") || "").trim(),
        whatsapp: this.whatsappE164(),
        aceite: !!this.querySelector(".kwp__consent input:checked"),
        cupom: this.dataset.cupom || "",
        id_lead: this.idLead(),
        utm_source: p("utm_source") || guardado.utm_source,
        utm_medium: p("utm_medium") || guardado.utm_medium,
        utm_campaign: p("utm_campaign") || guardado.utm_campaign,
        utm_content: p("utm_content") || guardado.utm_content,
        utm_term: p("utm_term") || guardado.utm_term,
        gclid: p("gclid") || guardado.gclid,
        fbclid: p("fbclid") || guardado.fbclid,
        cupom_do_link: p("discount") || "",
        pagina: location.pathname + location.search,
        landing_page: guardado.landing || location.pathname,
        referrer: guardado.referrer || document.referrer || "",
        gatilho: this.gatilho || "",
        segundos_ate_preencher: Math.round((Date.now() - this.abertoEm) / 1000),
        visitante: this.visitanteRecorrente() ? "recorrente" : "novo",
        dispositivo: matchMedia("(max-width: 767px)").matches
          ? "celular"
          : matchMedia("(max-width: 1024px)").matches
          ? "tablet"
          : "desktop",
        largura_tela: window.innerWidth,
        idioma: navigator.language || "",
        carrinho_itens: carrinho.itens,
        carrinho_valor: carrinho.valor,
        // O client_id do GA4 são os dois últimos trechos do cookie _ga.
        ga_client_id: ga ? ga.split(".").slice(-2).join(".") : "",
        fbp: cookie("_fbp"),
        fbc: cookie("_fbc") || (p("fbclid") ? "fb.1." + Date.now() + "." + p("fbclid") : ""),
        user_agent: navigator.userAgent,
      };
    }

    /* Guarda a origem na primeira página da sessão: sem isso, quem navega antes
       de preencher chega ao formulário sem UTM nenhuma. */
    origemDaSessao(url) {
      const chave = "kalpa-origem";
      try {
        const salvo = JSON.parse(sessionStorage.getItem(chave) || "null");
        if (salvo) return salvo;
        const campos = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
        const novo = { landing: location.pathname + location.search, referrer: document.referrer || "" };
        campos.forEach((c) => { novo[c] = url.searchParams.get(c) || ""; });
        sessionStorage.setItem(chave, JSON.stringify(novo));
        return novo;
      } catch (e) {
        return { landing: "", referrer: "" };
      }
    }

    visitanteRecorrente() {
      try {
        const chave = "kalpa-ja-veio";
        const antes = localStorage.getItem(chave);
        localStorage.setItem(chave, "1");
        return !!antes;
      } catch (e) {
        return false;
      }
    }

    idLead() {
      const aleatorio = crypto && crypto.randomUUID
        ? crypto.randomUUID().slice(0, 8)
        : Math.random().toString(36).slice(2, 10);
      return "kwp-" + Date.now().toString(36) + "-" + aleatorio;
    }

    async lerCarrinho() {
      this.carrinho = { itens: "", valor: "" };
      try {
        const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
        if (!r.ok) return;
        const c = await r.json();
        this.carrinho = { itens: c.item_count, valor: (c.total_price / 100).toFixed(2) };
      } catch (e) {}
    }

    /* Fila em localStorage: o registro só sai depois que o servidor confirma.
       A gravação leva ~2,6s e a pessoa pode fechar a aba antes — por isso o
       receptor descarta id_lead repetido. */
    enfileirar(registro) {
      try {
        const fila = JSON.parse(localStorage.getItem(this.filaChave) || "[]");
        fila.push(registro);
        localStorage.setItem(this.filaChave, JSON.stringify(fila.slice(-20)));
      } catch (e) {}
    }

    async escoarFila() {
      const url = this.dataset.leadsUrl;
      if (!url) return;

      let fila = [];
      try {
        fila = JSON.parse(localStorage.getItem(this.filaChave) || "[]");
      } catch (e) {
        return;
      }
      if (!fila.length) return;

      const sobraram = [];
      for (const registro of fila) {
        let entregue = false;
        try {
          // text/plain evita o preflight, que o App da Web não responde.
          const r = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(registro),
            keepalive: true,
            redirect: "follow",
          });
          entregue = r.ok;
        } catch (e) {
          entregue = false;
        }
        if (!entregue) sobraram.push(registro);
      }

      try {
        localStorage.setItem(this.filaChave, JSON.stringify(sobraram));
      } catch (e) {}
    }

    async copiar(botao) {
      const rotulo = botao.querySelector("[data-kwp-copy-label]");
      const codigo = botao.dataset.code;

      try {
        await navigator.clipboard.writeText(codigo);
      } catch (e) {
        const campo = document.createElement("textarea");
        campo.value = codigo;
        campo.setAttribute("readonly", "");
        campo.style.position = "fixed";
        campo.style.opacity = "0";
        document.body.appendChild(campo);
        campo.select();
        try {
          document.execCommand("copy");
        } catch (err) {
          return;
        } finally {
          document.body.removeChild(campo);
        }
      }

      if (!rotulo) return;
      rotulo.textContent = botao.dataset.labelCopied;
      clearTimeout(this.voltaRotulo);
      this.voltaRotulo = setTimeout(() => {
        rotulo.textContent = botao.dataset.labelCopy;
      }, 2400);
    }
  }

  if (!customElements.get("kalpa-welcome-popup")) {
    customElements.define("kalpa-welcome-popup", KalpaWelcomePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rituais"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === "undefined") return;

    if (typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
    }

    const section = document.querySelector(".orbital-section");
    if (!section) return;

    const activeSets = section.querySelectorAll(".orbital-group.active");

    activeSets.forEach((set) => {
      const wrapper = set.querySelector(".orbital-track");
      const images = set.querySelectorAll(".orbital-item-media");
      const buttons = set.querySelectorAll("button[data-ritual]");

      if (!wrapper || !images.length) return;

      let baseSpeed = 0.035;
      let boost = 0;
      let currentRotation = 0;
      let paused = false;
      let lastTime = performance.now();

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const applyRotation = () => {
        gsap.set(wrapper, { rotate: currentRotation });
        gsap.set(images, { rotate: -currentRotation });
      };

      const tick = (time) => {
        const delta = (time - lastTime) / 1000;
        lastTime = time;

        if (!paused) {
          currentRotation += (baseSpeed + boost) * delta * 360;
          boost *= 0.92;

          if (Math.abs(boost) < 0.0005) {
            boost = 0;
          }

          applyRotation();
        }

        requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);

      const addBoostFromScroll = (velocity) => {
        const normalized = clamp(velocity / 5000, -0.35, 0.35);
        boost += normalized;
        boost = clamp(boost, -0.6, 0.6);
      };

      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.create({
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          onUpdate: (self) => {
            addBoostFromScroll(self.getVelocity());
          },
        });
      } else {
        let lastScrollY = window.scrollY;
        let lastScrollTime = performance.now();

        window.addEventListener(
          "scroll",
          () => {
            const now = performance.now();
            const dy = window.scrollY - lastScrollY;
            const dt = now - lastScrollTime || 16;
            const velocity = (dy / dt) * 1000;

            addBoostFromScroll(velocity);

            lastScrollY = window.scrollY;
            lastScrollTime = now;
          },
          { passive: true }
        );
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
